import React from 'react';
import './style.scss';

// BulletListItems Component
const BulletListItems = ({ items }) => (
  <div className="bullet-list-items">
    {items.map((item, index) => (
      <BulletListItem key={index} item={item} />
    ))}
  </div>
);

// BulletListItem Component
const BulletListItem = ({ item }) => (
  <div className="bullet-list-item">
    <div className="bullet" />
    <Text text={item.text} />
  </div>
);

// Text Component
const Text = ({ text, style }) => (
  <div className="text" style={style}>
    {text}
  </div>
);

// Footer Component
const Footer = ({ footer, onTncClick }) => (
  <div className="bullet-list-footer">
    {footer.ctas.map((cta, index) => (
      <CTA key={index} cta={cta} onTncClick={onTncClick} />
    ))}
  </div>
);

// CTA Component
const CTA = ({ cta, onTncClick }) => (
  <a className="cta" href={cta.link} target="_blank" rel="noopener noreferrer" onClick={onTncClick}>
    {cta.label}
  </a>
);

// BulletList Component
const BulletList = ({ section, onTncClick }) => (
  <div className="bullet-list">
    <h3 className="bullet-list-header">{section.title}</h3>
    <BulletListItems items={section.listItems} />
    {section.footer && <Footer footer={section.footer} onTncClick={onTncClick} />}
  </div>
);

export default BulletList;
